import React from 'react';
import {
  SwipeableDrawer,
  useMediaQuery,
  useTheme,
  Box,
  makeStyles,
  createStyles,
  SwipeableDrawerProps,
  Typography,
  IconButton,
} from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';

const useStyles = makeStyles(({ breakpoints, spacing }) =>
  createStyles({
    drawerPaper: {
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      [breakpoints.up('sm')]: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: spacing(1.5),
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
      [breakpoints.up('sm')]: {
        marginTop: spacing(2),
        paddingLeft: spacing(5),
        paddingRight: spacing(5),
      },
    },
    root: {
      marginLeft: spacing(2),
      marginRight: spacing(2),
      [breakpoints.up('sm')]: {
        marginLeft: spacing(5),
        marginRight: spacing(5),
        width: 460,
      },
    },
  })
);

interface Props extends Omit<SwipeableDrawerProps, 'onOpen'> {
  hideHeader?: boolean;
  title?: string;
  onOpen?: React.ReactEventHandler<{}>;
}

export const CustomDrawer: React.FC<Props> = ({
  hideHeader = false,
  title,
  ...props
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <SwipeableDrawer
      onOpen={() => {}}
      disableSwipeToOpen
      anchor={isDesktop ? 'right' : 'bottom'}
      classes={{ paper: classes.drawerPaper }}
      {...props}
    >
      {!hideHeader && (
        <Box className={classes.header}>
          <Typography variant="h5">{title}</Typography>
          <Box mr={-1.5}>
            <IconButton
              onClick={props.onClose}
              aria-label="close drawer"
              component="span"
            >
              <CloseRoundedIcon />
            </IconButton>
          </Box>
        </Box>
      )}
      <Box className={classes.root}>{props.children}</Box>
    </SwipeableDrawer>
  );
};
